import FlightIcon from '@hashicorp/react-hds/src/components/flight-icon'
import Image from '@hashicorp/react-image'
import SectionHeader from '@hashicorp/react-section-header'

export default function PersonList({ data }) {
	return (
		<section className="c-person-list">
			<div className="g-grid-container">
				<SectionHeader className="g-section-header" headline={data.headline} />
				<ul className="people">
					{data.people.map((person) => (
						<PersonCard
							className={`person${data.people.length === 1 ? ' single' : ''}`}
							key={person.name}
							person={person}
						/>
					))}
				</ul>
			</div>
		</section>
	)
}

function PersonCard({ className, person }) {
	const { photo, name, company, socialProfiles, jobTitle } = person

	return (
		<li className={className}>
			<div className="person-image">
				{photo ? (
					<Image {...photo} alt={name} />
				) : (
					<div className="placeholder">
						<span className="initial">{getInitials(name)}</span>
					</div>
				)}
			</div>
			<div className="person-info">
				<span className="name">{name}</span>
				<span className="g-type-body-small job">
					{jobTitle}
					{company && `, ${company.name}`}
				</span>
				<ul className="social-links">
					{socialProfiles &&
						socialProfiles.map(({ url, networkName }) => (
							<li key={url}>
								<a href={url} rel="noopener noreferrer" target="_blank">
									<FlightIcon
										title={`${networkName} icon`}
										name={networkName}
										color="#D0D2D5"
										size={24}
									/>
								</a>
							</li>
						))}
				</ul>
			</div>
		</li>
	)
}

// Returns the first letters of the first and last names. Returns a single letter if
// one word is provided.
function getInitials(name) {
	return name
		.trim()
		.replace(/ +/gi, ' ') // Compress extra spaces
		.split(' ')
		.filter((n, i, a) => i === 0 || i === a.length - 1) // Get first and last words of name
		.reduce((acc, name) => acc + name[0], '') // Get first letters of each word
		.toUpperCase()
}
